import script from "./MaterialItemForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialItemForm.vue?vue&type=script&setup=true&lang=js"

import "./MaterialItemForm.vue?vue&type=style&index=0&id=14fb16c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fb16c6"]])

export default __exports__